var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBoolAscendingVariant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 30.333A4.65 4.65 0 004.667 35v9.333A4.65 4.65 0 009.333 49h9.334a4.65 4.65 0 004.666-4.667V35a4.65 4.65 0 00-4.666-4.667m.466 3.5l2.474 2.45-9.31 9.217-5.904-5.95L8.89 37.1l3.43 3.477M9.333 7a4.65 4.65 0 00-4.666 4.667V21a4.65 4.65 0 004.666 4.667h9.334A4.65 4.65 0 0023.333 21v-9.333A4.65 4.65 0 0018.667 7m-9.334 4.667h9.334V21H9.333M28 11.667h23.333v4.666H28m0 28v-4.666h23.333v4.666M28 25.667h23.333v4.666H28v-4.666z",
    fill: "#54DCF2"
  })));
}
export default SvgOrderBoolAscendingVariant;